// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentPatientLookupRequestModel {
    static getAttributeTypeMap() {
        return EnrollmentPatientLookupRequestModel.attributeTypeMap;
    }
}
EnrollmentPatientLookupRequestModel.discriminator = undefined;
EnrollmentPatientLookupRequestModel.additionalProperties = false;
EnrollmentPatientLookupRequestModel.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "string"
    },
    {
        "name": "postalCode",
        "baseName": "postalCode",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentPatientLookupRequestModel.js.map